import React from 'react';
import { motion } from 'framer-motion';
import { IoLocation, IoMail, IoCall } from "react-icons/io5";
import TransitionPage from '../TransitionPage';
import RevealText from '../components/TextReveal2';

function Contact() {
    return (
        <TransitionPage>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="min-h-[90vh] bg-gray-50 py-16 px-10 max-sm:px-5"
            >
                {/* Title */}
                <div className="text-center mb-16">
                    <RevealText
                        text="Connect With Us"
                        css="text-[#1E293B] poppins text-[3rem] max-sm:text-[2rem] font-bold"
                    />
                    <p className="text-gray-600 mt-4 max-w-xl mx-auto">
                        We’re always here to assist you. Reach out through any of the channels below.
                    </p>
                </div>

                {/* Contact Cards */}
                <div className="grid grid-cols-3 max-sm:grid-cols-1 gap-10 max-w-5xl mx-auto">
                    {/* Address */}
                    <div className="bg-white shadow-lg rounded-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition">
                        <IoLocation size={48} className="text-[#425472] mb-4" />
                        <h3 className="text-xl font-semibold mb-2">Address</h3>
                        <p className="text-gray-600">
                            F451, Phase-8B, Sector 74, Industrial Focal Point,<br />SAS Nagar(Mohali), Punjab, India-160055
                        </p>
                    </div>

                    {/* Email */}
                    <div className="bg-white shadow-lg rounded-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition">
                        <IoMail size={48} className="text-[#425472] mb-4" />
                        <h3 className="text-xl font-semibold mb-2">Email</h3>
                        <p className="text-gray-600">contact@accelorindia.com</p>
                    </div>

                    {/* Phone */}
                    <div className="bg-white shadow-lg rounded-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition">
                        <IoCall size={48} className="text-[#425472] mb-4" />
                        <h3 className="text-xl font-semibold mb-2">Phone</h3>
                        <p className="text-gray-600">+91 7080229840 / 42</p>
                        <p className="text-gray-600">+91 7080229843 / 44 (AMETL)</p>
                    </div>
                </div>

                {/* Google Map */}
                <div className="mt-16 max-w-5xl mx-auto rounded-lg overflow-hidden shadow-lg">
                    <iframe
                        className="w-full h-[60vh]"
                        title="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4717.042403928223!2d76.68069081221189!3d30.70219537449314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f9591d7eb2c97%3A0x9a557b8332e8ae10!2sACCELOR%20MICROSYSTEMS!5e1!3m2!1sen!2sin!4v1731132748815!5m2!1sen!2sin"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>

                {/* Optional CTA */}
                <div className="mt-12 text-center">
                    <a
                        href="https://ametlindia.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-[#425472] text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-md hover:bg-[#1E293B] transition"
                    >
                        Visit AMETL Laboratory
                    </a>
                </div>
            </motion.div>
        </TransitionPage>
    );
}

export default Contact;
